module.exports = __webpack_public_path__ + "static/chapelle-bb86a1726a97bc9f6bc5221971364a4b.jpg";